interface SeoHeadProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_ORIGIN = "https://hizmfjw.cn";
const OG_IMAGE =
  "https://readdy.ai/api/search-image?query=abstract%20editorial%20cover%20with%20warm%20coral%20amber%20and%20cream%20paper%20texture%2C%20artistic%20grain%2C%20bold%20graphic%20composition%2C%20magazine%20style&width=1200&height=630&seq=gua-og-cover&orientation=landscape";

export default function SeoHead({ title, description, keywords, path, jsonLd }: SeoHeadProps) {
  const canonical = `${SITE_ORIGIN}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="zh-CN" href={canonical} />
      <meta name="last-modified" content="2026-09-12" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="51.cg 今日吃瓜单" />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd]),
          }}
        />
      )}
    </>
  );
}